// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Using a 2 color palette technique. When styling symbols use
  "fill: inherit" to use the 1st set of colors
  "fill: currentColor" to use the 2nd set of colors
  More info on techniques: http://tympanus.net/codrops/2015/07/16/styling-svg-use-content-css/
*/

/*
 .expanded luminosity increased by (100 - collapsed luminosity) / 1.5
*/

.qg-icon {
    height: 1.5em;
    stroke-width: 0.8;
    stroke: hsl(0, 0%, 40%);
    color: hsl(0, 0%, 72%);
}

text.qg-table-text {
    text-anchor: middle;
    font-size: 7px;
    font-weight: bold;
    font-family: Monaco, Consolas, monospace;
    stroke: none;
    fill: hsl(0, 0%, 40%);
}`, "",{"version":3,"sources":["webpack://./../query-graphs/lib/ui/NodeIcon.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED;;CAEC;;AAED;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,wCAAwC;IACxC,YAAY;IACZ,qBAAqB;AACzB","sourcesContent":["/*\n  Using a 2 color palette technique. When styling symbols use\n  \"fill: inherit\" to use the 1st set of colors\n  \"fill: currentColor\" to use the 2nd set of colors\n  More info on techniques: http://tympanus.net/codrops/2015/07/16/styling-svg-use-content-css/\n*/\n\n/*\n .expanded luminosity increased by (100 - collapsed luminosity) / 1.5\n*/\n\n.qg-icon {\n    height: 1.5em;\n    stroke-width: 0.8;\n    stroke: hsl(0, 0%, 40%);\n    color: hsl(0, 0%, 72%);\n}\n\ntext.qg-table-text {\n    text-anchor: middle;\n    font-size: 7px;\n    font-weight: bold;\n    font-family: Monaco, Consolas, monospace;\n    stroke: none;\n    fill: hsl(0, 0%, 40%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
